import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_containers/packing_house_process/${packing_house_process_id}`
    );
  },

  fetchContainer(packing_house_id, packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_templates/container/${packing_house_process_id}/${container_id}`
    );
  },

  fetchTemplate(packing_house_id, container_id, quality_template_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_inspects/quality_template/${container_id}/${quality_template_id}`
    );
  },

  fetchQualityGroups(packing_house_id, quality_template_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/show_quality_inspect/list_quality_groups/${quality_template_id}`
    );
  },

  getQualityInspect(packing_house_id, quality_inspect_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/show_quality_inspect/${quality_inspect_id}`
    );
  }
};
